import { Controller } from "stimulus";

const FOLLOWUPS = {
  promoter: {
    title: "Thanks! What did you enjoy most?",
    placeholder: "What stood out about your experience?",
  },
  passive: {
    title: "Thanks! What would make this a 10 for you?",
    placeholder: "What's the one thing that would win you over?",
  },
  detractor: {
    title: "We're sorry it missed the mark — what would have made it better?",
    placeholder: "Tell us what went wrong so we can fix it.",
  },
};

export default class extends Controller {
  static targets = ["card", "option", "followupTitle", "feedback", "submit", "share", "reviewCta"];
  static values = { url: String, reviewUrl: String };

  connect() {
    this.selectedScore = null;
    this.handleKeydown = this.handleKeydown.bind(this);
    this.syncViewport = this.syncViewport.bind(this);

    document.addEventListener("keydown", this.handleKeydown);

    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", this.syncViewport);
      window.visualViewport.addEventListener("scroll", this.syncViewport);
      this.syncViewport();
    }

    this.element.classList.add("is-open");
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown);

    if (window.visualViewport) {
      window.visualViewport.removeEventListener("resize", this.syncViewport);
      window.visualViewport.removeEventListener("scroll", this.syncViewport);
    }
  }

  syncViewport() {
    const viewport = window.visualViewport;
    if (!viewport) return;

    this.element.style.height = `${viewport.height}px`;
    this.element.style.top = `${viewport.offsetTop}px`;
    this.element.style.bottom = "auto";

    if (this.hasFeedbackTarget && document.activeElement === this.feedbackTarget) {
      this.feedbackTarget.scrollIntoView({ block: "center" });
    }
  }

  selectScore(event) {
    const button = event.currentTarget;
    const score = parseInt(button.dataset.score, 10);
    const bucket = this.bucketFor(score);
    this.selectedScore = score;

    this.optionTargets.forEach((option) => {
      option.classList.remove("is-selected", "is-promoter", "is-passive", "is-detractor");
    });
    button.classList.add("is-selected", `is-${bucket}`);

    this.followupTitleTarget.textContent = FOLLOWUPS[bucket].title;
    this.feedbackTarget.placeholder = FOLLOWUPS[bucket].placeholder;
    this.cardTarget.classList.add("has-score");
  }

  submit() {
    if (this.selectedScore === null) return;

    this.submitTarget.disabled = true;

    const formData = new FormData();
    formData.append("client_nps[score]", this.selectedScore);
    formData.append("client_nps[feedback]", this.feedbackTarget.value);

    fetch(this.urlValue, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "X-CSRF-Token": localStorage.getItem("bp-x-csrf-token"),
        "X-Requested-With": "XMLHttpRequest",
      },
      credentials: "same-origin",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) throw new Error("Request failed");
        this.showThankYou();
      })
      .catch(() => {
        this.submitTarget.disabled = false;
      });
  }

  showThankYou() {
    if (this.hasShareTarget && this.bucketFor(this.selectedScore) === "promoter") {
      if (this.reviewUrlValue) this.reviewCtaTarget.href = this.reviewUrlValue;
      this.shareTarget.classList.add("is-visible");
    }

    this.cardTarget.classList.add("is-submitted");
  }

  backdropClose(event) {
    if (event.target === this.element) this.close();
  }

  handleKeydown(event) {
    if (event.key === "Escape") this.close();
  }

  bucketFor(score) {
    if (score >= 9) return "promoter";
    if (score >= 7) return "passive";
    return "detractor";
  }

  close() {
    this.element.classList.remove("is-open");
  }
}
